import sidebarAttributes from "./sidebar.json";
import legendAttributes from "./legend.json";
import titlePurchaseAttributes from "./titlepurchase.json";

export default {
  ...sidebarAttributes,
  ...legendAttributes,
  ...titlePurchaseAttributes,
};
